import { render, staticRenderFns } from "./NotificationSettingSwitch.vue?vue&type=template&id=856d0a08&scoped=true&"
import script from "./NotificationSettingSwitch.vue?vue&type=script&lang=js&"
export * from "./NotificationSettingSwitch.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSettingSwitch.vue?vue&type=style&index=0&id=856d0a08&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856d0a08",
  null
  
)

export default component.exports